import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { TechOperationAssetEntityType } from "../../../pages/tech-operations/shared/types/tech-operation-asset-entity";

import { ASSET_STOCKS_PAGE_MODULE_NAME } from "./constants";

export enum AssetStocksColumnId {
  Name = "name",
  AssetCategory = "assetCategory",
  Balance = "balance",
  MeasureUnit = "measureUnit",
}

export type AssetStocksFilter = {
  names: string[];
  categories: TechOperationAssetEntityType[];
  units: string[];
};

interface AssetStocksUiState {
  isFilterOpen: boolean;
  filter: AssetStocksFilter;
  isExporting: boolean;
}

const initialState: AssetStocksUiState = {
  isFilterOpen: false,
  filter: {
    names: [],
    categories: [],
    units: [],
  },
  isExporting: false,
};

export const assetStocksPageSlice = createSlice({
  name: ASSET_STOCKS_PAGE_MODULE_NAME,
  initialState,
  reducers: {
    toggleIsFilterOpenAction(state): void {
      state.isFilterOpen = !state.isFilterOpen;
    },
    setFilterAction(state, action: PayloadAction<AssetStocksFilter>): void {
      state.filter = action.payload;
    },
    resetFilterAction(state): void {
      state.filter = initialState.filter;
    },
    setIsExportingAction(state, action: PayloadAction<boolean>): void {
      state.isExporting = action.payload;
    },
  },
});

export const assetStocksPageReducer = assetStocksPageSlice.reducer;

export const {
  toggleIsFilterOpenAction,
  setFilterAction,
  resetFilterAction,
  setIsExportingAction,
} = assetStocksPageSlice.actions;
